import React, { useState, useContext, useEffect } from "react";
import { Modal, ModalBody, Button } from "@windmill/react-ui";
import BookingServices from "services/BookingServices";
import { notifyError, notifySuccess } from "utils/toast";
import LabelArea from "components/form/LabelArea";
import { SidebarContext } from "context/SidebarContext";
import SelectExecutives from "components/form/SelectExecutives";

const Tourexecutemodal = ({ isOpen, onClose, client_id, register, data }) => {
  const [selectedArrivalEmployee, setSelectedArrivalEmployee] = useState(null);
  const [arrivalVendorName, setArrivalVendorName] = useState(null);
  const [tourType, setTourType] = useState(""); // State for Arrival selection
  const { setIsUpdate } = useContext(SidebarContext);

  let result = null;

  data.forEach((clientData) => {
    if (String(clientData.client_id) === String(client_id)) {
      result = clientData;
    }
  });

  useEffect(() => {
    if (result?.arrival_executive?.trim() !== "") {
      setArrivalVendorName(result?.arrival_executive);
    }
  }, [result]);

  const handleArrivalChange = (employeeId) => {
    setSelectedArrivalEmployee(employeeId);
    setTourType("1");
  };

  const handleConfirm = async () => {
    if (!selectedArrivalEmployee) {
      notifyError("Please select an executive.");
      return;
    }
    try {
      const payload = { employee_id: selectedArrivalEmployee };
      const response = await BookingServices.Assignexecutive(
        client_id,
        tourType,
        payload
      );

      if (response.status) {
        notifySuccess(response.message);
      } else {
        notifyError(response.message);
      }

      setIsUpdate(true);
      onClose();
    } catch (error) {
      console.error("Error updating status:", error);
      notifyError("Error updating status.");
    }
  };

  const resetModal = () => {
    setSelectedArrivalEmployee(null);
    setTourType("");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={resetModal}
      style={{width:"400px"}}
      className="relative bg-white dark:bg-gray-700 dark:text-white p-2 rounded-md"
    >
      <ModalBody className="custom-modal">
        <p className="text-lg font-bold text-center">Assign Arrival</p>

        {/* Arrival Dropdown */}
        <div className="grid grid-cols-6 gap-4 mb-16">
          <div className="col-span-6">
          <LabelArea label="Arrival" />
            <SelectExecutives
              client_id={client_id}
              label="Arrival Executive"
              handleReferenceNoChange={handleArrivalChange}
              employee_name={arrivalVendorName}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-3 mt-4">
          <Button className="bg-green-500 text-white" onClick={handleConfirm}>
            Update
          </Button>
          <Button className="bg-gray-500 text-white" onClick={resetModal}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Tourexecutemodal;
